import React, { type ReactNode, type FC } from 'react'
import ImageAnswers from './Options/ImageAnswers'
import ShortAnswers from './Options/ShortAnswers'
import LongAnswers from './Options/LongAnswers'

interface IProps {
  type: IQuestion['type']
  answers: IAnswer[]
  userAnswer: IAnswer[]
  saveUserAnswer: (answer: any) => void
  answersLeft: number
  children: ReactNode
}

const Answers: FC<IProps> = ({ type, answers, userAnswer, saveUserAnswer, answersLeft, children }) => {
  const handleSaveAnswer = (answer: IAnswer): void => {
    if (answersLeft > 0 && !userHasAnswerToThis(answer)) {
      saveUserAnswer(answer)
    }
  }

  const userHasAnswerToThis = (option: any): boolean => userAnswer.some((answer) => answer.id === option.id)
  const getClassName = (option: IAnswer, classes: IClasses): string => {
    if (userHasAnswerToThis(option)) return `${classes.base} ${answersLeft > 0 ? classes.isWaiting : option.isCorrect ? classes.isCorrect : classes.isWrong}`
    if (answersLeft === 0 && option.isCorrect) return `${classes.base} ${classes.isCorrect}`
    else return `${classes.base} ${answersLeft > 0 && classes.hover}`
  }

  switch (type) {
    case 'long':
      return (
        <LongAnswers
          answers={answers}
          answersLeft={answersLeft}
          handleSaveAnswer={handleSaveAnswer}
          getClassName={getClassName}
        >
          {children}
        </LongAnswers>
      )
    case 'image':
      return (
        <ImageAnswers
          answers={answers}
          answersLeft={answersLeft}
          handleSaveAnswer={handleSaveAnswer}
          userHasAnswerToThis={userHasAnswerToThis}
          getClassName={getClassName}
        >
          {children}
        </ImageAnswers>
      )
    default:
      return (
        <ShortAnswers
          answers={answers}
          answersLeft={answersLeft}
          handleSaveAnswer={handleSaveAnswer}
          getClassName={getClassName}
        >
          {children}
        </ShortAnswers>
      )
  }
}

export default Answers
